import instance from "../config/interceptor";
import { PER_PAGE_SIZE } from "../utils/constants";
import { BASE_API_URL } from "../config/api";

export const getReportVisits = async ({
  page = 1,
  size = PER_PAGE_SIZE,
  from,
  to,
  sort = "practitionerId%2Cdesc",
  doctor_id,
}) => {
  let _response;
  try {
    let link = `${BASE_API_URL}/dashboard/practitioner-stats?`;
    link = link.concat("page=" + page);
    link = link.concat("&size=" + size);
    link = link.concat("&from=" + from);
    link = link.concat("&to=" + to);
    link = link.concat("&sort=" + sort);
    if (doctor_id) link = link.concat("&practitioner_id=" + doctor_id);

    const response = await instance.get(link);
    _response = response;
  } catch ({ response }) {
    _response = response;
  }
  return _response;
};

export const exportReportVisits = async ({
  page = 1,
  size = PER_PAGE_SIZE,
  from,
  to,
  sort = "start,desc",
  doctor_id,
}) => {
  let _response;
  try {
    let link = `${BASE_API_URL}/dashboard/practitioner-stats/export-to-csv?`;
    link = link.concat("page=" + page);
    link = link.concat("&size=" + size);
    link = link.concat("&from=" + from);
    link = link.concat("&to=" + to);
    link = link.concat("&sort=" + sort);
    if (doctor_id) link = link.concat("&practitioner_id=" + doctor_id);

    const response = await instance.get(link);
    _response = response;
  } catch ({ response }) {
    _response = response;
  }
  return _response;
};
